module.exports = __webpack_public_path__ + "img/clipboard (2).d71a2f95.webp";